/* eslint-disable react/jsx-props-no-spreading */
import { Fragment, useMemo } from 'react';
import Dynamic from '@base/Dynamic/Dynamic';
import { useIsPageInReduxContext } from '@context/IsPageInReduxContext';
import LoginFlow from './LoginFlow';

const PageReduxProvider = Dynamic(() =>
  import('@cont/App/PageReduxProviderWrapper')
);

const Login = (props) => {
  const hasReduxContext = useIsPageInReduxContext();

  const Wrapper = useMemo(
    () => (hasReduxContext ? Fragment : PageReduxProvider),
    [hasReduxContext]
  );

  return (
    <Wrapper>
      <LoginFlow {...props} />
    </Wrapper>
  );
};

export default Login;
